<script>
import api from '@utils/api'

export default {
  name: 'GoodsDelete',
  props: {
    goodsId: {
      type: Number,
      required: true,
      default: 0,
    },
    shortName: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    deleteGoods() {
      this.loading = true
      api.deleteGoods(this.goodsId).then(response => {
        this.dialog = false
        this.$emit('goods-deleted')
        this.loading = false
        this.$store.dispatch('data/updateDictionary', 'goods')
      })
    },
  },
}
</script>

<template>
  <v-layout row>
    <v-btn
      slot="activator"
      color="error"
      flat
      icon
      @click.native.stop="dialog = true">
      <v-icon>delete</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="355">
      <v-card>
        <v-card-title class="headline text-xs-center">
          <v-spacer />
          <div>{{ $t('titles__delete_goods') }} "{{ shortName }}"</div>
          <v-spacer />
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="loading"
            color="secondary"
            @click.native="dialog = false"
          >
            {{ $t('buttons__cancel') }}
          </v-btn>
          <v-btn
            :disabled="loading"
            :loading="loading"
            color="error"
            @click.native="deleteGoods"
          >
            {{ $t('buttons__delete') }}
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
